import { useRef, useEffect, useState } from 'react';

const cities = [
  'Elkhart', 'Goshen', 'Mishawaka', 'South Bend', 'Granger',
  'Nappanee', 'Bristol', 'Middlebury', 'Wakarusa', 'Osceola',
  'Dunlap', 'Simonton Lake', 'Millersburg', 'Shipshewana',
];

const ServiceAreaMap = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="service-area" ref={ref} className="py-20 md:py-28 bg-brand-dark">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className={`text-center mb-12 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-brand-amber/30 rounded-full mb-4">
            <span className="text-xs font-semibold text-brand-amber uppercase tracking-widest">Service Area</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4">
            Serving All of <span className="text-brand-amber italic">Michiana</span>
          </h2>
          <p className="text-white/60 text-base max-w-xl mx-auto">
            Based in Elkhart, Indiana — we serve residential and commercial clients within a 30-mile radius across the entire Michiana region.
          </p>
        </div>

        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          {/* Left Panel */}
          <div className="bg-brand-charcoal rounded-2xl p-8 flex flex-col justify-between border border-white/8">
            <div>
              <h3 className="font-serif text-2xl font-bold text-white mb-2">30-Mile Coverage from Elkhart</h3>
              <p className="text-white/60 text-sm mb-6">We proudly serve all communities throughout the Michiana area for both residential and commercial masonry and construction projects.</p>
              <div className="grid grid-cols-2 gap-2 mb-8">
                {cities.map((city) => (
                  <div key={city} className="flex items-center gap-2 text-sm text-white/70">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-brand-amber text-xs" />
                    </div>
                    {city}, IN
                  </div>
                ))}
                <div className="flex items-center gap-2 text-sm text-brand-amber font-medium col-span-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-add-circle-line text-brand-amber text-xs" />
                  </div>
                  And many more communities!
                </div>
              </div>
            </div>
            <div className="space-y-3">
              <button
                onClick={scrollToContact}
                className="w-full py-3.5 bg-brand-amber hover:bg-brand-amber-light text-white font-semibold rounded-lg transition-colors cursor-pointer flex items-center justify-center gap-2"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-2-line" />
                </div>
                Request Service in My Area
              </button>
              <a
                href="tel:+15744096118"
                className="w-full py-3.5 border border-white/20 hover:border-brand-amber text-white/80 hover:text-brand-amber font-semibold rounded-lg transition-all flex items-center justify-center gap-2"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line" />
                </div>
                Call 574-409-6118
              </a>
            </div>
          </div>

          {/* Right: Google Map */}
          <div className="rounded-2xl overflow-hidden border border-white/8 min-h-[400px]">
            <iframe
              title="Valley View Construction Service Area - Elkhart Indiana"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d193310.0!2d-85.9767!3d41.6820!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8816f3d0b4d91e05%3A0x5f47c3a9c60c0b23!2sElkhart%2C%20IN!5e0!3m2!1sen!2sus!4v1712000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ minHeight: '400px', border: 0, filter: 'grayscale(20%) contrast(1.05)' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreaMap;
